import '.ba{position:fixed;}.ssr-plugin'
import '.bb{inset:0px;}.ssr-plugin'
import '.dn{background:rgba(0,0,0,0.66);}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.d{align-items:center;}.ssr-plugin'
import '.c{justify-content:center;}.ssr-plugin'
import '.do{z-index:99;}.ssr-plugin'
import '.dp{animation-duration:1s;}.ssr-plugin'
import '.dq{animation-effect:ease-in;}.ssr-plugin'
import '.a7{position:relative;}.ssr-plugin'
import '.f{width:100%;}.ssr-plugin'
import '.b3{max-width:440px;}.ssr-plugin'
import '.b7{padding:32px;}.ssr-plugin'
import '.bk{gap:8px;}.ssr-plugin'
import '.dr{margin:24px;}.ssr-plugin'
import '.bc{overflow:hidden;}.ssr-plugin'
import '.dc{text-align:center;}.ssr-plugin'
import { styled } from 'inlines'
import { SpinningLoader } from './SpinningLoader'
import { useTheme } from '../providers/useTheme'
import { Text } from './Text'
import { useEffect } from 'react'
import { useTranslations } from '../hooks/useTranslations'
import { capitalize } from '../utils/capitalize'

export const StripeProcessing = ({
  isWaiting,
  isProcessing,
}: {
  isWaiting?: boolean
  isProcessing?: boolean
}) => {
  useEffect(() => {
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = ''
    }
  }, [])

  const { colors } = useTheme()
  const { data: dictionary } = useTranslations('checkout')

  return (
    <div className="ba bb dn a d c do"
    >
      <div className="dp dq"
        style={{
          '@keyframes': {
            '0%': {
              opacity: 0,
            },
            '100%': {
              opacity: 1,
            },
          },}}
      />

      <div className="a7 f b3 b7 d c bk dr bc dc"
        style={{
          backgroundColor: colors.background,
          border: `1px solid ${colors.border}`,}}
      >
        <SpinningLoader size={64} style={{ margin: '0 auto' }} />
        <Text
          color="gradient"
          variant="title"
          isMultiline
          style={{ textAlign: 'center', marginBottom: 6, marginTop: 12 }}
        >
          {capitalize(dictionary?.processing_payment ?? '')}
        </Text>
        <Text style={{ textAlign: 'center' }}>
          {capitalize(
            isWaiting || isProcessing
              ? dictionary?.processing_payment_message
              : dictionary?.processing_payment_long_wait,
          )}
        </Text>
      </div>
    </div>
  )
}
